module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-deal-customer-view"
  }, [_c('div', {
    staticClass: "z-deal-customer-title"
  }, [_vm._v(_vm._s(_vm.$props.title))]), _vm._l((Object.values(_vm.data.fields)), function(item) {
    return (item.show) ? _c('div', {
      staticClass: "z-deal-customer-view__value"
    }, [_c('div', {
      staticClass: "z-deal-customer-view__value-label"
    }, [_vm._v(_vm._s(item.label + ': '))]), _c('div', {
      staticClass: "z-deal-customer-view__value-value"
    }, [_vm._v(_vm._s((item.value) ? item.value : 'Не указанно'))])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4e1277","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZDealCustomerView.vue
// module id = 1095
// module chunks = 0